import type { ImageLoaderProps } from 'next/image';

import { CLIENT_ENVS, EXCLUDED_CDN_DOMAINS } from '@/helpers/constants';

export default function cloudfrontLoader({ src }: ImageLoaderProps) {
  if (
    CLIENT_ENVS.CMS_S3_URL &&
    CLIENT_ENVS.CMS_CDN_URL &&
    src.startsWith(CLIENT_ENVS.CMS_S3_URL)
  ) {
    return src.replace(CLIENT_ENVS.CMS_S3_URL, CLIENT_ENVS.CMS_CDN_URL);
  }

  if (
    EXCLUDED_CDN_DOMAINS.some((domain) =>
      typeof domain === 'string' ? src.includes(domain) : false
    )
  ) {
    return src;
  }

  const url = new URL(`${CLIENT_ENVS.IMG_CDN_URL}${src}`);
  // TODO: Enable searchParams once we are sure they are working
  // url.searchParams.set('format', 'auto');
  // url.searchParams.set('width', width.toString());
  // url.searchParams.set('quality', (quality || 75).toString());
  return url.href;
}
